import React, { useState } from "react";
import styled from "styled-components";
import { useQueryClient } from "@tanstack/react-query";
import { Button, Table, ButtonToolbar } from "components/bootstrap";
import { ConfirmDialog, Icon, IfPermitted } from "components/common";
import { InputStaticFieldsStore } from "stores/inputs/InputStaticFieldsStore";
import { StaticFieldForm } from "components/inputs";
import SectionGrid from "components/common/Section/SectionGrid";
import { KEY_PREFIX } from "hooks/usePaginatedInputs";
const StyledWrapper = styled.div`
  margin-top: ${(props) => props.theme.spacings.md};
`;
const StyledTable = styled(Table)`
  margin-top: ${(props) => props.theme.spacings.md};
`;
const StyledTd = styled.td`
  width: ${(props) => props.theme.spacings.md};
`;
const StyledSpan = styled.span`
  display: flex;
  justify-content: flex-end;
`;
const InputStaticFields = ({ input }) => {
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [showStaticFieldForm, setShowStaticFieldForm] = useState(false);
  const [fieldToDelete, setFieldToDelete] = useState(null);
  const queryClient = useQueryClient();
  const handleDeleteStaticField = () => {
    InputStaticFieldsStore.destroy(input, fieldToDelete).finally(() => {
      setFieldToDelete(null);
      setShowConfirmDelete(false);
      queryClient.invalidateQueries({ queryKey: KEY_PREFIX });
    });
  };
  const onDeleteStaticField = (fieldName) => {
    setFieldToDelete(fieldName);
    setShowConfirmDelete(true);
  };
  const deleteButton = (fieldName) => /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "transparent",
      bsSize: "xsmall",
      style: { verticalAlign: "baseline" },
      onClick: () => onDeleteStaticField(fieldName)
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "close" })
  );
  const formatStaticFields = (staticFields) => {
    const formattedFields = [];
    const staticFieldNames2 = Object.keys(staticFields);
    staticFieldNames2.forEach((fieldName) => {
      formattedFields.push(
        /* @__PURE__ */ React.createElement("tr", { key: `${fieldName}-field` }, /* @__PURE__ */ React.createElement("td", null, fieldName), /* @__PURE__ */ React.createElement("td", null, staticFields[fieldName]), /* @__PURE__ */ React.createElement(StyledTd, null, /* @__PURE__ */ React.createElement(ButtonToolbar, null, deleteButton(fieldName))))
      );
    });
    return formattedFields;
  };
  const staticFieldNames = Object.keys(input.static_fields);
  if (staticFieldNames.length === 0) {
    return /* @__PURE__ */ React.createElement("div", null);
  }
  return /* @__PURE__ */ React.createElement(StyledWrapper, null, /* @__PURE__ */ React.createElement(SectionGrid, null, /* @__PURE__ */ React.createElement("h4", null, "Static fields"), /* @__PURE__ */ React.createElement(StyledSpan, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: [`inputs:edit:${input.id}`, `input_types:create:${input.type}`] }, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "primary",
      bsSize: "xs",
      key: `add-static-field-${input.id}`,
      onClick: () => {
        setShowStaticFieldForm(true);
      }
    },
    "Add static field"
  )))), /* @__PURE__ */ React.createElement(StyledTable, { condensed: true, striped: true, hover: true }, /* @__PURE__ */ React.createElement("tbody", null, formatStaticFields(input.static_fields))), showConfirmDelete && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: "Delete static field",
      show: true,
      onConfirm: () => handleDeleteStaticField(),
      onCancel: () => setShowConfirmDelete(false)
    },
    `Are you sure you want to remove static field '${fieldToDelete}' from '${input.title}'?`
  ), showStaticFieldForm && /* @__PURE__ */ React.createElement(StaticFieldForm, { input, setShowModal: setShowStaticFieldForm }));
};
export default InputStaticFields;
